import carbon from "../../images/CarbonTracking (1).png";
import carbon1 from "../../images/CarbonTracking (2).png";
import carbon2 from "../../images/CarbonTracking (3).png";
import carbon3 from "../../images/CarbonTracking (4).png";
import carbon4 from "../../images/CarbonTracking (5).png";

const Badge = ({ label }) => (
  <span className="bg-[#E7F6EC] rounded-[10px] px-[10px] py-[6px] text-[14px] leading-[17px] text-[#006633] whitespace-nowrap">
    {label}
  </span>
);

const solutions = [
  {
    title: "Carbon Tracking",
    description:
      "CloseCarbon's carbon tracking feature allows users to monitor and analyze their carbon emissions in real-time, providing a comprehensive overview of their environmental impact. Users can easily track their progress, set reduction goals, and make informed decisions to contribute towards a more sustainable future.",
    badges: ["ISO-14064-1", "ISO-14064-2"],
    imageHeight: 323,
    imageFirst: true,
    image: carbon, // Use the correct image
  },
  {
    title: "Validation",
    description:
      "Validation is the initial step in CloseCarbon's crediting process. The purpose of validation is to determine whether a project meets the requirements for generating carbon credits. The validation is conducted by our in-house validator who assesses the eligibility and compliance of a project against specific standards or methodologies.",
    badges: ["Verra's VCS", "ISO-14064-3"],
    imageHeight: 352,
    imageFirst: false,
    image: carbon1, // Use the correct image
  },
  {
    title: "Verification",
    description:
      "Verification is the process of confirming the accuracy and reliability of the carbon credits generated by a project. It is carried out by an independent third-party verifier who assesses the project's compliance with the relevant standards and methodologies.",
    badges: ["Verra's VCS", "ISO-14064-3"],
    imageHeight: 319,
    imageFirst: true,
    image: carbon2, // Use the correct image
  },
  {
    title: "Carbon Incentives",
    description:
      "CloseCarbon allows for issuance of voluntary carbon credit by third-party regulatory bodies after a project passes verification and validation. For each metric ton of CO₂ or its equivalent (CO₂e) reduced by a project, one CloseCarbon Reduction Tonne will be issued. Credits can be generated through various emission reduction projects, such as renewable energy installations, energy efficiency improvements, or infrastructure change projects.",
    badges: ["Verra's VCS", "ISO-14064-1", "ISO-14064-2", "ISO-14064-3"],
    imageHeight: 410,
    imageFirst: false,
    image: carbon3, // Use the correct image
  },
  {
    title: "Energy Sharing",
    description:
      "CloseCarbon's Energy Sharing feature enables users to participate in a secure, peer-to-peer solar energy marketplace. Sellers can share surplus renewable energy directly with other users, while buyers gain access to affordable, clean power. This fosters community-driven energy access, maximizes renewable energy use, and accelerates the transition to a low-carbon energy future.",
    badges: ["ISO-50011"],
    imageHeight: 352,
    imageFirst: true,
    image: carbon4, // Use the correct image
  },
  {
    title: "Energy Efficiency",
    description:
      "CloseCarbon's Energy Efficiency as a Service feature helps users identify, implement, and track energy-saving opportunities across their operations. By providing clear insights into energy consumption patterns and reduction potential, it empowers users to optimize energy use, cut costs, and lower emissions — all with measurable, verified results that support long-term sustainability goals.",
    badges: ["ISO-50015", "ISO-50001", "ISO-50006", "IPMVP"],
    imageHeight: 352,
    imageFirst: false,
    image: carbon, // Adjust this to your actual Energy Efficiency image
  },
];

export default function CarbonTracking() {
  return (
    <section className="w-full bg-white mb-20">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        <div className="flex flex-col items-center gap-12 sm:gap-16 lg:gap-20">
          {solutions.map(({ title, description, badges, imageHeight, imageFirst, image }) => {
            const textBlock = (
              <div className="flex flex-col gap-4 sm:gap-6 w-full lg:w-[514px]">
                <h2 className="text-[28px] sm:text-[32px] lg:text-[36px] font-bold leading-[1.2] text-[#0D924F] m-0">
                  {title}
                </h2>
                <p className="text-[18px] sm:text-[20px] lg:text-[24px] font-normal leading-[1.3] text-[#3B3B3B] m-0">
                  {description}
                </p>
                <div className="flex flex-row flex-wrap items-center gap-3 sm:gap-5">
                  {badges.map((b) => (
                    <Badge key={b} label={b} />
                  ))}
                </div>
              </div>
            );

            const imageBlock = (
              <div 
                className="rounded-[6.3125px] flex-shrink-0 w-full lg:w-[606px] overflow-hidden"
                style={{ height: imageHeight }}
              >
                <img 
                  src={image} 
                  alt={title}
                  className="w-full h-full object-cover rounded-[6.3125px] hover:scale-105 transition-transform duration-300"
                />
              </div>
            );

            return (
              <div
                key={title}
                className={`
                  flex flex-col w-full gap-8 sm:gap-12 lg:gap-20
                  ${imageFirst ? 'lg:flex-row' : 'lg:flex-row-reverse'}
                `}
              >
                {imageBlock}
                {textBlock}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}